import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { MarketingCampaignState, ScheduledCampaign } from '../../components/marketingCampaign/types';

const initialState: MarketingCampaignState = {
  campaigns: [],
  loading: false,
  error: null,
  selectedCampaign: null,
};

const marketingCampaignSlice = createSlice({
  name: 'marketingCampaign',
  initialState,
  reducers: {
    fetchMarketingCampaignsRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchMarketingCampaignsSuccess: (state, action: PayloadAction<ScheduledCampaign[]>) => {
      state.loading = false;
      state.campaigns = action.payload;
    },
    fetchMarketingCampaignsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedCampaign: (state, action: PayloadAction<ScheduledCampaign | null>) => {
      state.selectedCampaign = action.payload;
    },
    clearMarketingCampaigns: (state) => {
      state.campaigns = [];
      state.error = null;
      state.selectedCampaign = null;
    },
  },
});

export const {
  fetchMarketingCampaignsRequest,
  fetchMarketingCampaignsSuccess,
  fetchMarketingCampaignsFailure,
  setSelectedCampaign,
  clearMarketingCampaigns,
} = marketingCampaignSlice.actions;

export default marketingCampaignSlice.reducer;
